import React from 'react';
import './restore.css'
function restore () {
    
        return (
            <div>
<div className="container-fluid">

    <div className="row justify-content-center">

        <div className="">

            <div className="restorePageWrapper">

                <div className="restorePageContainer">

                    {/* <!-- HEADER --> */}
                    <div className="restoreHeaderTitle">
                        Khôi phục dữ liệu
                    </div>

                    <div className="restoreBreadcrumbText">
                        Trang chủ / Sao lưu dữ liệu / Khôi phục dữ liệu
                    </div>

                    {/* <!-- SEARCH --> */}
                    <div className='restoreSearchRow'>
                    <div className="restoreSearchSectionTitle">
                        Chọn bản sao lưu để khôi phục
                    </div>

                    <div className="row ">

                        {/* <!-- DATE --> */}
                        <div className="col-md-5 restoreSearchGroup">

                            <label className="restoreSearchLabel">
                                Thời gian sao lưu
                            </label>

                            <div className="restoreDateRangeWrapper">

                                <div className="restoreDateInputBox">

                                    <input
                                        type="text"
                                        className="restoreDateInputField"
                                        placeholder="Từ ngày"
                                    />

                                    <div className="restoreDateInputIcon">
                                        📅
                                    </div>

                                </div>

                                <div className="restoreDateArrow">
                                    →
                                </div>

                                <div className="restoreDateInputBox">

                                    <input
                                        type="text"
                                        className="restoreDateInputField"
                                        placeholder="Đến ngày"
                                    />

                                    <div className="restoreDateInputIcon">
                                        📅
                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* <!-- TYPE --> */}
                        <div className="col-md-2 restore-search-group">

                            <label className="restoreSearchLabel">
                                Loại sao lưu
                            </label>

                            <select className="restoreSelectField">
                                <option>-- Tất cả --</option>
                            </select>

                        </div>

                        {/* <!-- STATUS --> */}
                        <div className="col-md-2 restore-search-group-status">

                            <label className="restoreSearchLabel">
                                Trạng thái
                            </label>

                            <select className="restoreSelectField">
                                <option>-- Tất cả --</option>
                            </select>

                        </div>

                        {/* <!-- USER --> */}
                        <div className="col-md-3 restore-search-group-user-action">

                            <label className="restoreSearchLabel">
                                Người thực hiện
                            </label>

                            <div className="restoreSearchInputWrapper">

                                <input
                                    type="text"
                                    className="restore-search-input-field-user"
                                    placeholder="Nhập tên người thực hiện..."
                                />

                                <div className="restoreSearchInputIcon">
                                    🔍
                                </div>

                            </div>

                        </div>

                        {/* <!-- BUTTON --> */}
                    </div>
                    <div className='row'>
                           <div className="col-md-12">

                            <div className="restoreActionButtonWrapper">

                                <button className="restoreResetButton">
                                    ↻ Đặt lại
                                </button>

                                <button className="restoreSearchButton">
                                    🔍 Tìm kiếm
                                </button>

                            </div>

                        </div>
                    </div>
                    </div>


                    {/* <!-- TABLE --> */}
                    <div className="restoreTableSection">

                        <div className="restoreTableTitle">
                            Danh sách bản sao lưu
                        </div>

                        <div className="restoreTableWrapper">

                            <table className="restoreDataTable">

                                <thead className="restoreTableHead">

                                    <tr className="restoreTableHeadRow">

                                        <th className="restoreTableHeadCell">STT</th>
                                        <th className="restoreTableHeadCell">Tên bản sao lưu</th>
                                        <th className="restoreTableHeadCell">Loại sao lưu</th>
                                        <th className="restoreTableHeadCell">Thời gian bắt đầu</th>
                                        <th className="restoreTableHeadCell">Thời gian kết thúc</th>
                                        <th className="restoreTableHeadCell">Dung lượng</th>
                                        <th className="restoreTableHeadCell">Người thực hiện</th>
                                        <th className="restoreTableHeadCell">Trạng thái</th>
                                        <th className="restoreTableHeadCell">Ghi chú</th>
                                        <th className="restoreTableHeadCell">Thao tác</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr className="restoreTableBodyRow">
                                        <td className="restoreTableBodyCell">
                                            <input
                                                type="radio"
                                                className="restoreRadioInput"
                                                checked
                                            />
                                            1
                                        </td>
                                        <td className="restoreTableBodyCell">Backup_20240520_0230</td>
                                        <td className="restoreTableBodyCell">Tự động</td>
                                        <td className="restoreTableBodyCell">20/05/2024 02:30:15</td>
                                        <td className="restoreTableBodyCell">20/05/2024 02:32:45</td>
                                        <td className="restoreTableBodyCell">256.45 MB</td>
                                        <td className="restoreTableBodyCell">system</td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreEyeButton">
                                                👁
                                            </span>
                                        </td>
                                    </tr>

                                    <tr className="restoreTableBodyRow">
                                        <td className="restoreTableBodyCell">
                                            <input
                                                type="radio"
                                                className="restoreRadioInput"
                                            />
                                            2
                                        </td>
                                        <td className="restoreTableBodyCell">Backup_20240519_0230</td>
                                        <td className="restoreTableBodyCell">Tự động</td>
                                        <td className="restoreTableBodyCell">19/05/2024 02:30:11</td>
                                        <td className="restoreTableBodyCell">19/05/2024 02:32:20</td>
                                        <td className="restoreTableBodyCell">254.12 MB</td>
                                        <td className="restoreTableBodyCell">system</td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreEyeButton">
                                                👁
                                            </span>
                                        </td>
                                    </tr>

                                    <tr className="restoreTableBodyRow">
                                        <td className="restoreTableBodyCell">
                                            <input
                                                type="radio"
                                                className="restoreRadioInput"
                                            />
                                            3
                                        </td>
                                        <td className="restoreTableBodyCell">Backup_20240518_0230</td>
                                        <td className="restoreTableBodyCell">Tự động</td>
                                        <td className="restoreTableBodyCell">18/05/2024 02:30:13</td>
                                        <td className="restoreTableBodyCell">18/05/2024 02:32:19</td>
                                        <td className="restoreTableBodyCell">255.01 MB</td>
                                        <td className="restoreTableBodyCell">system</td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreEyeButton">
                                                👁
                                            </span>
                                        </td>
                                    </tr>

                                    <tr className="restoreTableBodyRow">
                                        <td className="restoreTableBodyCell">
                                            <input
                                                type="radio"
                                                className="restoreRadioInput"
                                            />
                                            4
                                        </td>
                                        <td className="restoreTableBodyCell">Backup_20240517_0900</td>
                                        <td className="restoreTableBodyCell">Thủ công</td>
                                        <td className="restoreTableBodyCell">17/05/2024 09:00:05</td>
                                        <td className="restoreTableBodyCell">17/05/2024 09:02:33</td>
                                        <td className="restoreTableBodyCell">312.67 MB</td>
                                        <td className="restoreTableBodyCell">admin</td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            Sao lưu trước khi cập nhật hệ thống
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreEyeButton">
                                                👁
                                            </span>
                                        </td>
                                    </tr>

                                    <tr className="restoreTableBodyRow">
                                        <td className="restoreTableBodyCell">
                                            <input
                                                type="radio"
                                                className="restoreRadioInput"
                                            />
                                            5
                                        </td>
                                        <td className="restoreTableBodyCell">Backup_20240516_0230</td>
                                        <td className="restoreTableBodyCell">Tự động</td>
                                        <td className="restoreTableBodyCell">16/05/2024 02:30:12</td>
                                        <td className="restoreTableBodyCell">16/05/2024 02:32:18</td>
                                        <td className="restoreTableBodyCell">253.89 MB</td>
                                        <td className="restoreTableBodyCell">system</td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                        <td className="restoreTableBodyCell">
                                            <span className="restoreEyeButton">
                                                👁
                                            </span>
                                        </td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>

                        {/* <!-- PAGINATION --> */}
                        <div className="restorePaginationContainer">

                            <div className="restorePaginationLeft">

                                <div className="restorePaginationText">
                                    Hiển thị
                                </div>

                                <select className="restorePaginationSelect">
                                    <option>10</option>
                                </select>

                                <div className="restorePaginationText">
                                    dòng trên mỗi trang
                                </div>

                            </div>

                            <div className="restorePaginationRight">
                                <div className='one-five'>
                                    1-5 trong 5
                                </div>

                                <button className="restorePaginationButton">
                                    «
                                </button>

                                <button className="restorePaginationButton">
                                    ‹
                                </button>

                                <button className="restorePaginationButtonActive">
                                    1
                                </button>

                                <button className="restorePaginationButton">
                                    ›
                                </button>

                                <button className="restorePaginationButton">
                                    »
                                </button>

                            </div>

                        </div>

                    </div>

                    {/* <!-- INFO --> */}
                    {/* <div className="restoreInfoSection">

                        <div className='row'>
                            <div className='col-sm-6'>
                           <div className="restoreInfoTitle">
                            Thông tin bản sao lưu sẽ khôi phục
                        </div>
                         
                            <div>

                                <div className="restoreInfoLabel">
                                    Tên bản sao lưu:
                                </div>

                                <div className="restoreInfoValue">
                                    Backup_20240520_0230
                                </div>

                                <div className="restoreInfoLabel">
                                    Loại sao lưu:
                                </div>

                                <div className="restoreInfoValue">
                                    Tự động
                                </div>

                                <div className="restoreInfoLabel">
                                    Thời gian bắt đầu:
                                </div>

                                <div className="restoreInfoValue">
                                    20/05/2024 02:30:15
                                </div>

                                <div className="restoreInfoLabel">
                                    Thời gian kết thúc:
                                </div>

                                <div className="restoreInfoValue">
                                    20/05/2024 02:32:45
                                </div>

                                <div className="restoreInfoLabel">
                                    Dung lượng:
                                </div>

                                <div className="restoreInfoValue">
                                    256.45 MB
                                </div>

                                <div className="restoreInfoLabel">
                                    Người thực hiện:
                                </div>

                                <div className="restoreInfoValue">
                                    system
                                </div>

                                <div className="restoreInfoLabel">
                                    Ghi chú:
                                </div>

                                <div className="restoreInfoValue">
                                    Sao lưu tự động hàng ngày
                                </div>

                                <div className="restoreInfoLabel">
                                    Mô tả:
                                </div>

                                <div className="restoreInfoValue">
                                    Sao lưu tự động toàn bộ hệ thống
                                </div>

                            </div>
                            </div>
                        </div>

                        <div className="restoreInfoGrid">

                          

                            
                            <div>

                                <div className="restoreScopeTitle">
                                    Phạm vi khôi phục
                                </div>

                                <div className="restoreScopeOption">

                                    <label className="restoreScopeLabel">

                                        <input
                                            type="radio"
                                            className="restoreScopeRadio"
                                            checked
                                        />

                                        Khôi phục toàn bộ hệ thống

                                    </label>

                                    <div className="restoreScopeDescription">
                                        Khôi phục toàn bộ dữ liệu và cấu hình hệ thống về thời điểm sao lưu
                                    </div>

                                </div>

                                <div className="restoreScopeOption">

                                    <label className="restoreScopeLabel">

                                        <input
                                            type="radio"
                                            className="restoreScopeRadio"
                                        />

                                        Khôi phục theo module

                                    </label>

                                    <div className="restoreScopeDescription">
                                        Chọn các module để khôi phục
                                    </div>

                                    <select className="restoreModuleSelect">
                                        <option>Chọn module cần khôi phục...</option>
                                    </select>

                                </div>

                                <div className="restoreScopeOption">

                                    <label className="restoreScopeLabel">

                                        <input
                                            type="radio"
                                            className="restoreScopeRadio"
                                        />

                                        Khôi phục dữ liệu tùy chọn

                                    </label>

                                    <div className="restoreScopeDescription">
                                        Chọn dữ liệu cụ thể để khôi phục
                                    </div>

                                    <button className="restoreChooseButton">
                                        📁 Chọn dữ liệu
                                    </button>

                                </div>

                            </div>

                        </div>

                        
                        <div className="restoreWarningBox">
                            ⚠ Lưu ý: Quá trình khôi phục sẽ ghi đè dữ liệu hiện tại bằng dữ liệu từ bản sao lưu.
                            <br />
                            Vui lòng đảm bảo đã sao lưu dữ liệu hiện tại nếu cần thiết.
                        </div>

                       
                        <div className="restoreFooterAction">

                            <button className="restoreCancelButton">
                                ✖ Hủy bỏ
                            </button>

                            <button className="restoreSubmitButton">
                                ⟳ Khôi phục dữ liệu
                            </button>

                        </div>

                    </div> */}
                      <div className="restoreContainer pageContainer">
  <div className="row justify-content-center">

            <div className="col-12">

                <div className="restoreWrapper">

                    <div className="mainLayout">
{/* 
                        <!-- LEFT --> */}
                        <div className="leftContent">

                            <div className="leftTitle">
                                Thông tin bản sao lưu sẽ khôi phục
                            </div>

                            <div className="backupInfoGrid">

                                <div className="backupLabel">
                                    Tên bản sao lưu:
                                </div>

                                <div className="backupValue">
                                    Backup_20240520_0230
                                </div>

                                <div className="backupLabel">
                                    Loại sao lưu:
                                </div>

                                <div className="backupValue">
                                    Tự động
                                </div>

                                <div className="backupLabel">
                                    Thời gian bắt đầu:
                                </div>

                                <div className="backupValue">
                                    20/05/2024 02:30:15
                                </div>

                                <div className="backupLabel">
                                    Thời gian kết thúc:
                                </div>

                                <div className="backupValue">
                                    20/05/2024 02:32:45
                                </div>

                                <div className="backupLabel">
                                    Dung lượng:
                                </div>

                                <div className="backupValue">
                                    256.45 MB
                                </div>

                                <div className="backupLabel">
                                    Người thực hiện:
                                </div>

                                <div className="backupValue">
                                    system
                                </div>

                                <div className="backupLabel">
                                    Ghi chú:
                                </div>

                                <div className="backupValue">
                                    Sao lưu tự động hằng ngày
                                </div>

                                <div className="backupLabel">
                                    Mô tả:
                                </div>

                                <div className="backupValue">
                                    Sao lưu tự động toàn bộ hệ thống
                                </div>

                            </div>

                            {/* <!-- WARNING --> */}
                            <div className="warningArea">

                                <div className="warningBox">

                                    <div className="warningFlex">

                                        <div className="warningIcon">
                                            ⚠
                                        </div>

                                        <p className="warningText">
                                            Lưu ý: Quá trình khôi phục sẽ ghi đè dữ liệu hiện tại bằng dữ liệu từ bản sao lưu.
                                            <br />
                                            Vui lòng đảm bảo đã sao lưu dữ liệu hiện tại nếu cần thiết.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* <!-- RIGHT --> */}
                        <div className="rightContent">

                            <div className="rightTitle">
                                Phạm vi khôi phục
                            </div>

                            {/* <!-- option 1 --> */}
                            <div className="restoreOption">

                                <div className="optionHeader">

                                    <input
                                        className="optionRadio"
                                        type="radio"
                                        name="restoreType"
                                        checked
                                    />

                                    <div className="optionTitle">
                                        Khôi phục toàn bộ hệ thống
                                    </div>

                                </div>

                                <div className="optionDescription">
                                    Khôi phục toàn bộ dữ liệu và cấu hình hệ thống về thời điểm sao lưu
                                </div>

                            </div>

                            {/* <!-- option 2 --> */}
                            <div className="restoreOption">

                                <div className="optionHeader">

                                    <input
                                        className="optionRadio"
                                        type="radio"
                                        name="restoreType"
                                    />

                                    <div className="optionTitle">
                                        Khôi phục theo module
                                    </div>

                                </div>

                                <div className="optionDescription">
                                    Chọn các module để khôi phục
                                </div>

                                <select className="moduleSelect">

                                    <option>
                                        Chọn module cần khôi phục...
                                    </option>

                                </select>

                            </div>

                            {/* <!-- option 3 --> */}
                            <div className="restoreOption">

                                <div className="optionHeader">

                                    <input
                                        className="optionRadio"
                                        type="radio"
                                        name="restoreType"
                                    />

                                    <div className="optionTitle">
                                        Khôi phục dữ liệu tùy chọn
                                    </div>

                                </div>

                                <div className="optionDescription">
                                    Chọn dữ liệu cụ thể để khôi phục
                                </div>

                                <button className="chooseButton">
                                    📁 Chọn dữ liệu
                                </button>

                            </div>

                            {/* <!-- footer --> */}
                            <div className="footerAction">

                                <button className="cancelButton">
                                    ✕ Hủy bỏ
                                </button>

                                <button className="submitButton">
                                    ⟳ Khôi phục dữ liệu
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

  </div>


                </div>

            </div>

        </div>

    </div>

</div>

            </div>
        );
   
}



export default restore;